import Api from '@/api/Api'

class WishlistItem extends Api {
  protected resource = 'wishlist-items'

  public async store<T>(request: SaveWishlistItemRequest) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}`)
      .post(request)
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async destroy<T>(id: number) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/${id}`)
      .delete()
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async saveToCollection<T>(id: number, request: SaveItemToCollectionRequest) {
    const { data, error, response } = await this.fetch<T>(`${this.resource}/${id}/save-to-wishlist`)
      .put(request)
      .json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new WishlistItem()
